var swiper_main = new Swiper('.image-txt-carousel', {
    loop: true,
    slidesPerView: 'auto',
    spaceBetween: 25,
    grabCursor: true,
    navigation: {
        nextEl: '.image-next',
        prevEl: '.image-prev'
    },
    breakpoints: {
        1025: {
            spaceBetween: 30
        }
    }
});
swiper_main.on('slideChange', function () {
    const index_currentSlide = swiper_main.realIndex;
    const currentSlide = swiper_main.slides[index_currentSlide]

    let review = currentSlide.dataset.customerReview;
    let name =  currentSlide.dataset.customerName;
    let date =  currentSlide.dataset.customerDate;
    document.querySelector('[data-appy-review]').innerHTML = review;
    document.querySelector('[data-appy-name]').innerHTML = name;
    document.querySelector('[data-appy-date]').innerHTML = date;  
});